import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var responseSchema = yup.object({
  needToShow: yup.boolean().required(),
  bodyEmail: yup.string().required(),
  bodySms: yup.string().required(),
  subject: yup.string().required(),
  successMessage: yup.string().required(),
});

var composeResponse = (response) => {
  var data = response.data.data || {};
  return {
    needToShow: Boolean(data.send_email_status),
    bodyEmail: data.appointment_email_text,
    bodySms: data.appointment_sms,
    subject: data.appointment_subject,
    successMessage: data.success_msg,
  };
};

export function useAppointmentCancelNotificationQuery(
  { appointmentId },
  options = {},
) {
  return useQuery(
    [QUERY_KEYS.appointments.cancelNotification, appointmentId],
    async () => {
      var res = await http.get(
        HTTP_ENDPOINTS.appointments.getCancelNotitication(appointmentId),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
}
